import React, { useContext } from 'react';
import { useStyletron } from 'baseui';
import { CustomDrawer, DrawerContext, CustomModal, Loader } from 'commons-ui';

import TransactionHistoryList from './list';
import useTransactionHistory from './useTransactionHistory';
import GetTransactionPdf from './transactionPdf';
import GetTransactionHistory from './getTransactionHistoryFilter';

const TransactionHistory = () => {
	const { drawerConfig, setDrawerConfig } = useContext(DrawerContext);
	const { getTransactionData, currentBalance, handleFilterSubmit, forceUpdate, showLoader } = useTransactionHistory();

	const [css] = useStyletron();

	return (
		<>
			{showLoader && <Loader />}
			<div>
				<div
					className={css({
						height: '60px',
						display: 'flex',
						alignItems: 'center',
						backgroundColor: 'white',
						paddingLeft: '10px',
						paddingRight: '20px',
						borderTop: '1px solid rgb(242, 242, 242)',
						justifyContent: 'space-between',
						width: '100vw'
					})}>
					<GetTransactionHistory handleFilterSubmit={handleFilterSubmit} />
					<div className={css({ display: 'flex', alignItems: 'center', gap: '30px' })}>
						<GetTransactionPdf />
						<div
							className={css({
								display: 'flex',
								justifyContent: 'center',
								gap: '15px'
							})}>
							<div
								className={css({
									fontSize: '16px',
									fontWeight: 'bold'
								})}>
								Current Balance (₹):
							</div>
							<div>{currentBalance}</div>
						</div>
					</div>
				</div>
				<TransactionHistoryList getTransactionData={getTransactionData} globalForceUpdate={forceUpdate} />
				<CustomDrawer drawerConfig={drawerConfig} setDrawerConfig={setDrawerConfig} />
				<CustomModal />
			</div>
		</>
	);
};

export default TransactionHistory;
